import React, {useState, useEffect} from 'react';
import CallToAction from '../../components/CallToAction/CallToAction';
import Aux from '../../hoc/Aux/Aux';
import CampaignFlowXs from '../../assets/images/spardaimpuelsle2026-startgrafik-mobil-rgb.svg';
import CampaignFlowLg from '../../assets/images/spardaimpuelsle2026-startgrafik-desktop-rgb.svg';
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";
import {cleanLocationProp, sendVirtualPageView} from "../../shared/utility";
import {Row, Col} from 'reactstrap';
import axios from '../../axios-base';
import {Helmet} from "react-helmet";
import {useLocation} from 'react-router-dom';

function Home(props) {
    const [ctas, setCtas] = useState(null);
    let location = useLocation();
    useEffect(() => {
        axios.get('/cta/', {
            params: {
                page: cleanLocationProp(location.pathname)
            }
        })
            .then(response => {
                setCtas(response.data);
            })
            .catch(error => {
                this.setState({error: true});
            });
        sendVirtualPageView("Willkommen");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    let cta = (
        <React.Fragment>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
        </React.Fragment>
    );
    if (ctas) {
        cta = ctas.map((cta, key) => (
            <React.Fragment key={key}>
                {key === 2 ?
                    <Col sm="6" className="my-3 d-flex align-items-center flex-column">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={CampaignFlowLg}/>
                            <img src={CampaignFlowXs}
                                 style={{width: "100%"}}
                                 alt="Landkreis-Challenge
Doppelte Förderung in den stärksten drei Landkreisen"/>
                        </picture>
                        {/*<CampaignFlow phases={props.votingPhases} />*/}
                    </Col>
                    : null}
                <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                    <CallToAction
                        btnClass={`anl_cta--${cta.page}--btn-${cta.position}`}
                        headline={cta.headline}
                        copy={cta.copy}
                        buttonText={cta.buttonText}
                        buttonColor={cta.buttonColor}
                        linkUrl={cta.linkUrl}
                        outline={cta.outline}
                        buttonVisibility={cta.buttonVisibility}
                    />
                </Col>
            </ React.Fragment>
        ));
    }

    return (
        <Aux>
            <Helmet>
                <title>{`Willkommen | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>
            <Row>
                {cta}
            </Row>
        </Aux>
    );
}

export default Home;
